import React from "react";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import { string } from "prop-types";

const NoMoreData = ({ imageSrc, textId }) => (
    <div className="text-center no-more-data" key="noMoreMovements">
        <div className="illustration-wrapper">
            <Image src={imageSrc} className="svg-big-icon" />
        </div>
        <p className="text-lead">
            <I18n id={textId} />
        </p>
    </div>
);

NoMoreData.propTypes = {
    imageSrc: string,
    textId: string,
};

NoMoreData.defaultProps = {
    imageSrc: "images/coloredIcons/folder-empty.svg",
    textId: "accounts.sumary.noRsults",
};
export default NoMoreData;
